import React, { Component } from "react";
import Dashboard from "../Dashboard";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { connect } from 'react-redux'
import { Redirect } from "react-router-dom"
import modele_liste from '../../utils/assets/docs/modele_liste.xlsx'
import { fetchReauthenticateMembersAction } from  '../../actions/Authentification/Reauthenticate'

class Entreprise extends Component {
  componentDidMount() {
    document.title = `Dashboard Membre | Entreprise`
    const { reauthenticateMembers, getReauthenticate } = this.props

    if (Object.keys(reauthenticateMembers.userData).length === 0) {
      getReauthenticate()
    }
  }
  render() {
    const { match, reauthenticateMembers } = this.props

    return (
      <div>
        <Header userIsSuccessLogin={reauthenticateMembers.isSuccess} />
          {reauthenticateMembers.isLoading
            ?
              <div className="aps-spinner-container-loading">
                <div className="uk-spinner">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                     <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="14"></circle>
                  </svg>
                </div>
                <div className="aps-section-register-desc">chargement en cours</div>
              </div>
            :
              <Dashboard match={match}>
                <div className="aps-dashboard-body-second-content">
                  <div className="aps-dashboard-body-container-title">
                    <p className="uk-text-center aps-dashboard-body-title" style={{marginLeft: "10%", marginRight: "10%"}}>
                      La souscription des personnes morales n&apos;est pas disponible en ligne.
                    </p>
                  </div>
                  <div className="aps-dashboard-body-container-desc">
                    <p className="uk-text-center aps-dashboard-body-desc">
                      Les tarifs indiqués sont dégressifs à partir de 10 salariés et la procédure de souscription simplifiée (pas de questionnaire médical et couverture des pathologies préexistantes).<br />
                      Demandez un devis sans engagement en envoyant à
                      <a className="uk-link-text" href="mailto:contact@aps-benin.com"> contact@aps-benin.com </a>
                      la liste des personnes à assurer (téléchargez et complétez le modèle ci-dessous).
                    </p>
                  </div>
                  <div className="uk-text-center">
                    <a className="uk-button aps-btn-green" href={modele_liste} target="_blank">
                      Télecharger le modèle de souscription
                    </a>
                  </div>
                </div>
                {reauthenticateMembers.isError &&
                  <div>
                    <Redirect to='/connexion' push/>
                  </div>
                }
              </Dashboard>
            }
          <Footer/>
        </div>
      )
  }
}

const mapStateToProps = ({ reauthenticateMembers, }) => {
  return {
    reauthenticateMembers,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getReauthenticate: () => dispatch(fetchReauthenticateMembersAction()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Entreprise)



// WEBPACK FOOTER //
// ./src/containers/Entreprise/index.js